import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { currency } from "../../App";
import { WishlistContext } from "../../Context/WishlistContext";
import { FiHeart } from "react-icons/fi";
import { FaHeart } from "react-icons/fa";

const Item = (props) => {
  const { toggleWishlist, isWishlisted } = useContext(WishlistContext);
  const wishlisted = isWishlisted(props.id);

  const slugify = (text) =>
    text.toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/--+/g, "-")
      .replace(/^-+|-+$/g, "");

  const handleWishlist = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist({
      id: props.id,
      name: props.name,
      image: props.image,
      new_price: props.new_price,
    });
  };

  return (
    <div className="group bg-white w-full max-w-[98%] mt-3 overflow-hidden h-auto flex flex-col rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
      <Link to={`/product/${props.id}/${slugify(props.name)}`} onClick={() => window.scrollTo(0, 0)}>
        <div className="relative overflow-hidden aspect-square sm:h-[400px] flex items-center justify-center bg-gray-50">
          <img
            crossOrigin="anonymous"
            src={props.image}
            alt={props.name}
            loading="lazy"
            className="group-hover:scale-105 transition-transform duration-500 object-cover w-full h-full"
          />

          {/* Hover overlay */}
          <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
            <span className="bg-white text-purple-700 font-semibold text-sm px-5 py-2 rounded-full shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
              View Product
            </span>
          </div>

          {/* Discount badge */}
          {props.discountPercentage > 0 && (
            <div className="absolute top-2 left-2 bg-gradient-to-r from-purple-600 to-purple-400 text-white text-[10px] sm:text-xs font-bold px-2 py-1 rounded-full shadow">
              {props.discountPercentage}% OFF
            </div>
          )}

          {/* Heart / Wishlist button */}
          <button
            onClick={handleWishlist}
            className="absolute top-2 right-2 z-10 w-8 h-8 rounded-full flex items-center justify-center shadow-md transition-all duration-200 hover:scale-110 active:scale-95"
            style={{
              background: wishlisted
                ? "linear-gradient(135deg,#8353C6,#9E79D2)"
                : "rgba(255,255,255,0.92)",
              border: wishlisted ? "none" : "1.5px solid #EEE5FA",
            }}
            title={wishlisted ? "Remove from wishlist" : "Add to wishlist"}
          >
            {wishlisted
              ? <FaHeart size={13} color="white" />
              : <FiHeart size={13} style={{ color: "#8353C6" }} />
            }
          </button>
        </div>
      </Link>

      <div className="p-3 sm:p-4 flex-grow flex flex-col justify-between">
        <p className="text-xs sm:text-sm md:text-[15px] font-medium text-gray-800 mt-1 sm:mt-2 line-clamp-2 leading-snug">
          {props.name}
        </p>
        <div className="flex flex-wrap gap-1 sm:gap-2 mt-2 items-baseline">
          <span className="text-sm sm:text-base font-bold text-purple-700">
            From {currency}{props.new_price}
          </span>
          {props.old_price && (
            <span className="text-[10px] sm:text-xs text-gray-400 line-through">
              {currency}{props.old_price}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Item;
